<template>
  <div
    class="pp-rubric-section-text mb-3"
    v-html="localInteraction.interactionText"
  ></div>
</template>

<script>
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'RubricSection',
  mixins: [
    Interaction,
  ],
};
</script>